const userManagerAppRoutes = {
  ROOT: "/manage",

  USERS_VIEW_RELATIVE: "users",
  USERS_VIEW_ABSOLUTE: "/manage/users",

  ROLES_VIEW_RELATIVE: "roles",
  ROLES_VIEW_ABSOLUTE: "/manage/roles",

  ADMIN_PANEL_RELATIVE: "admin",
  ADMIN_PANEL_ABSOLUTE: "/manage/admin",

  COMPANY_SETTINGS_RELATIVE: "company-settings",
  COMPANY_SETTINGS_ABSOLUTE: "/manage/company-settings",

  IMPORTS_RELATIVE: "imports",
  IMPORTS_ABSOLUTE: "/manage/imports",

  SECURITY_LOGS_RELATIVE: "security-logs",
  SECURITY_LOGS_ABSOLUTE: "/manage/security-logs",

  DYNAMIC_ROLES_RELATIVE: "roles/dynamic-rules",
  DYNAMIC_ROLES_ABSOLUTE: "/manage/roles/dynamic-rules",
  LEGACY_DYNAMIC_ROLES_RELATIVE: "dynamic-roles",
  LEGACY_DYNAMIC_ROLES_ABSOLUTE: "/manage/dynamic-roles",

  AD_GROUPS_RELATIVE: "roles/ad-groups",
  AD_GROUPS_ABSOLUTE: "/manage/roles/ad-groups",
  LEGACY_AD_GROUPS_RELATIVE: "ad-groups",
  LEGACY_AD_GROUPS_ABSOLUTE: "/manage/ad-groups",

  SKILLPANEL_DASHBOARDS_RELATIVE: "roles/skillpanel-dashboards",
  SKILLPANEL_DASHBOARDS_ABSOLUTE: "/manage/roles/skillpanel-dashboards",

  ASSISTANT_RELATIVE: "assistant",
  ASSISTANT_ABSOLUTE: "/manage/assistant",

  TEAMS_RELATIVE: "teams",
  TEAMS_ABSOLUTE: "/manage/teams",

  REPORTS_RELATIVE: "reports",
  REPORTS_ABSOLUTE: "/manage/reports",

  PROVISIONING_RELATIVE: "provisioning",
  PROVISIONING_ABSOLUTE: "/manage/provisioning",

  ACCESS_REQUESTS_RELATIVE: "access-requests",
  ACCESS_REQUESTS_ABSOLUTE: "/manage/access-requests",

  CREATE_ACCESS_REQUEST_RELATIVE: "access-requests/new",
  CREATE_ACCESS_REQUEST_ABSOLUTE: "/manage/access-requests/new",
};

export const routePaths = {
  LOGIN: "/login",
  RESET_PASSWORD: "/reset",
  SET_PASSWORD: "/setPassword",
  INVITATION: "/invitation/:invitationToken",
  PARTNERS: "/partners",
  SUPPORT_CODE: "/supportCode",
  RUN_AS: "/runAs",
  OAUTH2_AUTHORIZE: "/oauth2/authorize",
  ACCESS_REQUEST_APPROVAL: "/accessRequest/approve",
  ACCESS_REQUEST_DENY: "/accessRequest/deny",
  PRODUCTS_VIEW: "/",
  SECURITY: "/security",
  SECURITY_TWO_FACTOR_SETUP: "/security/two-factor/setup/:step",
  USER_MANAGER_APP: userManagerAppRoutes,
};
